import {
  ADD_ALERT,
  ADD_ALERT_FAIL,
  ADD_ALERT_SUCCESS,
  DELETE_ALERT,
  DELETE_ALERT_FAIL,
  DELETE_ALERT_SUCCESS,
  GET_ALERTS,
  GET_ALERTS_FAIL,
  GET_ALERTS_SUCCESS,
  UPDATE_ALERT,
  UPDATE_ALERT_FAIL,
  UPDATE_ALERT_SUCCESS,
} from "./actionTypes";

export const addAlert = alert => ({
  type: ADD_ALERT,
  payload: { alert },
});

export const addAlertSuccess = alert => ({
  type: ADD_ALERT_SUCCESS,
  payload: alert,
});

export const addAlertFail = error => ({
  type: ADD_ALERT_FAIL,
  payload: error,
});

export const getAlerts = clubId => ({
  type: GET_ALERTS,
  payload: clubId,
});

export const getAlertsSuccess = alerts => ({
  type: GET_ALERTS_SUCCESS,
  payload: alerts,
});

export const getAlertsFail = error => ({
  type: GET_ALERTS_FAIL,
  payload: error,
});

export const updateAlert = alert => ({
  type: UPDATE_ALERT,
  payload: alert,
});

export const updateAlertSuccess = () => ({
  type: UPDATE_ALERT_SUCCESS,
});

export const updateAlertFail = error => ({
  type: UPDATE_ALERT_FAIL,
  payload: error,
});

export const deleteAlert = id => ({
  type: DELETE_ALERT,
  payload: id,
});

export const deleteAlertSuccess = () => ({
  type: DELETE_ALERT_SUCCESS,
});

export const deleteAlertFail = error => ({
  type: DELETE_ALERT_FAIL,
  payload: error,
});
